// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_c77b407","stakeInfo":"_0f93911","returnInfo":"_9ec2567"};